module.exports = __webpack_public_path__ + "img/us.f4cc0b5e.svg";